import TotalGuestAvgSpendPresenter from "./TotalGuestAvgSpendPresenter";
import BaseListPage from "../../../base/BaseListPage";
import withRouter from "../../../withRouter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import AvgSpendGuestReport from "./components/AvgSpendGuestReport";
import MonthSelect from "../../discount-cost/salesDiscountAmount/components/MonthSelect";
import YearSelect from "../../discount-cost/salesDiscountAmount/components/YearSelect";
import { exportGuestsAndSpendingCSV } from "./utils/guestSpendingCsvUtils";
import {
  getAvgSpendGuestChartData,
  getAvgSpendGuestChartOptions,
} from "./utils/avgSpendGuestChartUtils";
import { getMonthRangesForYear } from "./utils/monthUtils";
import ProgressLoader from "../../../components/ProgressLoader";
import PageHeader from "../../../components/PageHeader";
import CustomSelect from "../../../components/CustomSelect";

class TotalGuestAvgSpendPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalGuestAvgSpendPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      selectedStoreCode: "",
      selectedMonth: "",
      selectedYear: "",
      storess: "",
      store: [],
      range: "",
      selectedMonth: "",
      selectedMonthName: "",
      notFound: false,
    };
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", ""),
    );

    return [...new Set(storeCodes)];
  }

  handleDropdownChange(event) {
    const monthNames = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    let monthName;
    this.setState({ selectedMonth: event.target.value });

    if (event.target.value === "AllMonths") {
      this.presenter.onChangeDate("AllMonths");
    } else {
      this.setState({ range: event.target.value });
      this.presenter.onChangeDate(JSON.parse(event.target.value));
      const monthi = JSON.parse(event.target.value).$gte.split("-");
      monthName = Object.keys(monthNames).find(
        (key) => monthNames[key] === monthi[1],
      );
    }
    this.setState({ selectedMonthName: monthName });
  }

  months() {
    return getMonthRangesForYear(this.state.selectedYear);
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  handleYearChange = (event) => {
    const year = event.target.value;
    let parsedRange = JSON.parse(this.state.range);

    parsedRange.$gte =
      year + parsedRange.$gte.substring(parsedRange.$gte.indexOf("-"));
    parsedRange.$lte =
      year + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));

    this.presenter.onChangeDate(parsedRange);
    this.setState({ selectedYear: event.target.value });
  };

  exportToCSV = () => {
    const {
      objects,
      selectedStoreCode,
      selectedMonthName,
      range,
      selectedYear,
      storess,
    } = this.state;

    const chartData = getAvgSpendGuestChartData({
      objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
    });

    exportGuestsAndSpendingCSV({
      chartData,
      selectedYear,
      range,
      storess,
      fileName: "GuestsAndSpending.csv",
    });
  };
  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const {
      objects,
      selectedStoreCode,
      selectedMonth,
      selectedMonthName,
      selectedYear,
      storess,
    } = this.state;

    const chartData = getAvgSpendGuestChartData({
      objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
    });
    const chartOptions = getAvgSpendGuestChartOptions(chartData);

    const chartId = "chart-container11";

    const storeOptions = [
      { value: "AllStore", label: "All Store" },
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode,
    );

    console.log("this.state.selectedMonth", this.state.selectedMonth);
    console.log("this.state.selectedMonthName", this.state.selectedMonthName);

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Total Guest vs. Avg Spend per Guest"
            subtitle="Relationship between guest count and average spend"
            icon="bi bi-graph-up"
          />
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              // isDisabled={!this.state.range}
              // error={
              //   !this.state.range ? "Please select a date range first" : ""
              // }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
          <MonthSelect
            selectedMonth={this.state.selectedMonth}
            selectedMonthName={this.state.selectedMonthName}
            months={this.months.bind(this)}
            onChange={this.handleDropdownChange.bind(this)}
          />
          <YearSelect
            selectedYear={this.state.selectedYear}
            onChange={this.handleYearChange.bind(this)}
            yearsCount={3}
            className="col-sm-3"
          />
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 && (
          <AvgSpendGuestReport
            chartOptions={chartOptions}
            chartData={chartData}
            storess={storess}
            chartRef={this.chartRef11}
            containerId="chart-container11"
          />
        )}

        {this.state.notFound && (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        )}

        {this.state.objects?.length === 0 &&
          this.state.storess &&
          this.state.selectedMonthName &&
          this.state.selectedYear &&
          !this.state.notFound && (
            <div className="text-center mt-5">
              <DefaultState />
            </div>
          )}

        {!this.state.selectedYear && <InitialPrompt twoFilter={false} />}
      </>
    );
  }
}

export default withRouter(TotalGuestAvgSpendPage);
